import { VonageError } from '@vonage/client-sdk';

export function serializeError(error: unknown) {
  if (error instanceof VonageError) {
    return { errorMessage: error.message, errorCode: error.code };
  }
  if (error instanceof Error) {
    return { errorMessage: error.message };
  }
  return { errorMessage: String(error) };
}

const TERMINAL_VONAGE_ERROR_CODES = [
  'voice:error:no_call_found',
  'voice:error:invalid_call_action',
  'voice:error:no_invite_found',
  'voice:error:no_leg_found',
  'voice:error:member_not_in_conversation',
];

const TERMINAL_CALL_STATE_PATTERNS = [
  'no call found',
  'invalid call action',
  'invalid-member-state',
  'member has not joined the conversation',
  'no invite found',
  'no leg found',
];

export const isTerminalCallStateError = (error: unknown): boolean => {
  // Check VonageError.code first (most reliable)
  if (error instanceof VonageError && error.code) {
    if (TERMINAL_VONAGE_ERROR_CODES.includes(error.code)) {
      return true;
    }
  }
  // Fallback to message matching for plain Error instances
  if (!(error instanceof Error)) {
    return false;
  }
  const message = error.message.toLowerCase();
  return TERMINAL_CALL_STATE_PATTERNS.some((pattern) => message.includes(pattern));
};

export function isNetworkFetchError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }
  const message = error.message.toLowerCase();
  return (
    (error instanceof TypeError && message.includes('failed to fetch')) ||
    (error instanceof TypeError && message.includes('network request failed')) ||
    (error instanceof TypeError && message.includes('network error')) ||
    message.includes('networkerror') ||
    message.includes('aborted')
  );
}
